// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"5c4162c4","986":"f803a3cb"}[chunkId] + ".chunk.css";
};